/* precision.js — the CAD PRECISION contract (2026-07-14 mandate, Issue 5).
 *
 * All engine geometry is metres in float64. Binary floats can't hold 0.001
 * exactly, so "millimetre precision" is defined operationally:
 *
 *   quantMm(v)   — snap a metre value onto the 1mm grid deterministically
 *                  (round(v·1000)/1000). Applied at every INTERACTIVE commit
 *                  (drag frames, drops, magnets) so a cabinet's stored
 *                  coordinate always displays as the same whole millimetre it
 *                  was placed at — after save, reload, undo, redo and drag.
 *                  Typed inputs already arrive as mm/1000 and pass through
 *                  unchanged (round-trip stable by construction).
 *
 * NEVER quantize inside pure geometry MATH (offsets, mitres, SAT) — only at
 * the moment a user-visible coordinate is committed to state.
 */
export function quantMm(v) {
  return Math.round(v * 1000) / 1000;
}
